import SDUBanner from 'components/ProductPage/DeliveryOptions/SDUBanner/SDUBanner';
import { withSDUBannerProps } from 'viewModel/productPage/deliveryOptions/sduBanner/withSDUBannerProps';

export default withSDUBannerProps(SDUBanner);
